import { render, staticRenderFns } from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=template&id=e2c827dc&scoped=true&"
import script from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
export * from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=style&index=0&id=e2c827dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c827dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2c827dc')) {
      api.createRecord('e2c827dc', component.options)
    } else {
      api.reload('e2c827dc', component.options)
    }
    module.hot.accept("./NetaMultiAttractionDetailsMenuComponent.vue?vue&type=template&id=e2c827dc&scoped=true&", function () {
      api.rerender('e2c827dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/neta/neta-multi-attraction/NetaMultiAttractionDetailsMenuComponent.vue"
export default component.exports